import { PromotionBanner } from "@clipboard-health/ui-components";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import type { TierType } from "@src/appV2/redesign/Tiers/api/schema";
import { TIERS_FULL_PATH } from "@src/appV2/redesign/Tiers/paths";
import { useHistory } from "react-router-dom";

interface TiersBannerProps {
  workerTier: TierType;
  workerId: string;
}

export function TiersBanner(props: TiersBannerProps) {
  const { workerTier, workerId } = props;
  const history = useHistory();

  function handleClick() {
    history.push(TIERS_FULL_PATH);
    logEvent(APP_V2_USER_EVENTS.TIERS_ACCOUNT_BANNER_CLICKED, { workerId, workerTier });
  }

  // eslint-disable-next-line default-case
  switch (workerTier) {
    case "GOLD": {
      return (
        <PromotionBanner
          title="Gold Membership"
          subtitle="View your exclusive perks"
          icon="gold-badge-colored"
          backgroundColor={(theme) => theme.palette.tiers!.gold.background}
          borderVariant="none"
          onClick={() => {
            handleClick();
          }}
        />
      );
    }

    case "SILVER": {
      return (
        <PromotionBanner
          title="Silver Membership"
          subtitle="Learn how to unlock exclusive perks"
          icon="silver-badge-colored"
          backgroundColor={(theme) => theme.palette.tiers!.silver.background}
          borderVariant="none"
          onClick={() => {
            handleClick();
          }}
        />
      );
    }

    case "LIMITED": {
      return (
        <PromotionBanner
          title="Limited Access"
          subtitle="Learn how to unlock unlimited bookings"
          icon="restricted-badge-colored"
          backgroundColor={(theme) => theme.palette.tiers!.limited.background}
          borderVariant="none"
          onClick={() => {
            handleClick();
          }}
        />
      );
    }
  }
}
